import { Copy } from 'lucide-react';
import React, { useState } from 'react';
import { useNavigate, generatePath } from 'react-router-dom';

import { Button } from '@epoch-ui/components/Button';
import { LinkButton } from '@epoch-ui/components/LinkButton';
import { useToaster } from 'hooks/useToaster';
import { DASHBOARD_EVENT_EDITOR_ROUTE } from 'constants/routes';

import { DuplicateEventModal } from '../components/DuplicateEventModal';

export const DuplicateEventSection = (): React.ReactElement => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { showToast } = useToaster();
  const navigate = useNavigate();

  const handleDuplicateEvent = (): void => {
    setIsModalOpen(true);
  };

  // Show success toast with link to new event
  const onDuplicate = (eventId: number): void => {
    showToast(
      <span>
        Event duplicated.{' '}
        <LinkButton
          variant="link"
          className="tw-h-5 tw-cursor-pointer tw-p-0 tw-font-normal tw-text-white"
          onClick={() =>
            navigate(generatePath(DASHBOARD_EVENT_EDITOR_ROUTE, { id: String(eventId) }))
          }
        >
          Go to event
        </LinkButton>
      </span>
    );
  };

  return (
    <div>
      <h2 className="tw-m-0 tw-text-xl tw-font-medium tw-leading-7">Duplicate event</h2>

      <p className="tw-mb-0 tw-mt-1 tw-text-sm tw-leading-5 tw-text-primary-grey">
        Duplicating this event will create a draft with a copy of this event, except for the guest
        list.
      </p>

      <Button
        size="xs"
        className="tw-mt-5 tw-gap-2 tw-rounded-xl"
        variant="secondary"
        onClick={handleDuplicateEvent}
      >
        <Copy size={16} />
        Duplicate event
      </Button>

      <DuplicateEventModal
        open={isModalOpen}
        onOpenChange={(open) => {
          if (!open) {
            setIsModalOpen(false);
          }
        }}
        onDuplicate={onDuplicate}
      />
    </div>
  );
};
